import axios from "axios";
import { callShowMessage } from "../utils/messageHelper";
import qs from "qs";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
});

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 403 && data?.code === "MUST_CHANGE_PASSWORD") {
        callShowMessage(data.msg || "Please reset your password.", "warning");
      } else if (status === 401) {
        localStorage.clear();
        callShowMessage("Session expired. Please log in again.", "error");
        window.location.href = "/login";
      } else if (status === 403) {
        console.log("Access denied: You do not have permission.");
        callShowMessage(
          "Access denied: You do not have permission.",
          "warning"
        );
      } else if (status >= 500) {
        callShowMessage("Server error. Please try again later.", "error");
      }
    } else {
      callShowMessage("Network error. Please check your connection.", "error");
    }

    return Promise.reject(error);
  }
);

export default instance;
